export default __webpack_public_path__ + "static/media/004-santa hat.589e266f.svg";